import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "rentalListingExtraction";

export const useRentalListingExtractionStore = defineStore(storeName, () => {
  const { baseMultipartPost, basePost } = useBase(storeName);
  const extraction = ref(null);
  const isExtracting = ref(false);
  const isApplying = ref(false);

  const extract = async (file, firstPages, lastPages, callback, errorCallback) => {
    isExtracting.value = true;
    extraction.value = null;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("first_pages", firstPages);
    formData.append("last_pages", lastPages);
    await baseMultipartPost(
      "rental-listing-extractions",
      formData,
      (data) => {
        extraction.value = data;
        isExtracting.value = false;
        if (callback) callback(data);
      },
      (errors) => {
        isExtracting.value = false;
        if (errorCallback) errorCallback(errors);
      },
    );
  };

  const extractIdentity = async (files, callback, errorCallback) => {
    const formData = new FormData();
    const fileArray = Array.isArray(files) ? files : [files];
    fileArray.forEach((file) => formData.append("files[]", file));
    await baseMultipartPost(
      "rental-listing-extractions/extract-id",
      formData,
      (data) => {
        if (callback) callback(data);
      },
      (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    );
  };

  const apply = async (reviewedData, callback, errorCallback) => {
    isApplying.value = true;
    await basePost(
      "rental-listing-extractions/apply",
      reviewedData,
      (data) => {
        isApplying.value = false;
        if (callback) callback(data);
      },
      (errors) => {
        isApplying.value = false;
        if (errorCallback) errorCallback(errors);
      },
    );
  };

  const uploadIdentityToPhysicalPerson = async (
    physicalPersonId,
    files,
    callback,
    errorCallback,
  ) => {
    const formData = new FormData();
    const fileArray = Array.isArray(files) ? files : [files];
    fileArray.forEach((file) => formData.append("files[]", file));
    formData.append("physical_person_id", physicalPersonId);
    await baseMultipartPost(
      "rental-listing-extractions/upload-identity-documents",
      formData,
      (data) => {
        if (callback) callback(data);
      },
      (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    );
  };

  const reset = () => {
    extraction.value = null;
    isExtracting.value = false;
    isApplying.value = false;
  };

  return {
    extraction,
    isExtracting,
    isApplying,
    extract,
    extractIdentity,
    apply,
    uploadIdentityToPhysicalPerson,
    reset,
  };
});
